import React, {useEffect, useState} from "react";

import {BillLine, BillRestControllerApiFactory, Budget, BudgetRestControllerApiFactory,} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Alert, Box, Grid, Modal, TextField, Typography} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";
import {useCustomerNotes} from "../bill/form";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import {dedicationModalStyle} from "../../../employee/modal";
import {numberToString} from "../../../../components/utils/numbers";
import {Link} from "react-router-dom";

export const BudgetEditPage = () => {
	const apiManager = useApiManager();
	const [showLines, setShowLines] = useState<boolean>(false);
	const [lines, setLines] = useState<BillLine[]>([]);

	const ctrl = apiManager.factory(BudgetRestControllerApiFactory);
	const billCtrl = apiManager.factory(BillRestControllerApiFactory);
	const {customerNotes, setCustomerId} = useCustomerNotes();


	useEffect(() => {
		if (showLines) {
			billCtrl.budgetLinesBill(form.getId() as number)
			.then(resp => setLines(resp.data))
		}
	}, [showLines]);


	const form = useForm({
		fetcher: (id) => {
			const res = ctrl.getBudget(id)
			res.then(d => setCustomerId(d.data.customer.id))
			return res;
		},
		updater: (bean) => ctrl.saveBudget(bean),
		remover: (id) => ctrl.deleteOrDismissBudget(id),
		factory: () => {
			return {} as Budget;
		},
		extraActions: [
			{
				label: "Líneas de facturas",
				action: () => {
					setShowLines(true);
					// navigate("/app/admin/billing/bill?budgetId=" + form.getId());
				},
			},
		]
	} as UseFormProps<Budget>);


	const averagePriceHour = (lines: BillLine[]) => {
		let avg = 0;
		let quantity = 0;
		if (lines.length > 0) {
			for (let line of lines) {
				const avg1 = line.quantity * line.unitNetPrice;
				avg += avg1;
				quantity += line.quantity;
			}

		}
		if (quantity > 0) {
			return numberToString(avg / quantity);
		}
		return "";
	}

	const totalQuantity = (lines: BillLine[]) => {

		let quantity = 0;
		if (lines.length > 0) {
			for (let line of lines) {
				quantity += line.quantity;
			}

		}
		return numberToString(quantity);
	}

	return (
		<>
			<FormContent form={form} title={"Formulario de presupuesto"}>

				<Grid container spacing={2}>
					<Grid item xs={8}>
						<Grid container spacing={2}>
							<Grid item sm={3}>
								<FormAutocomplete field={"customer"} label={"Cliente"} type={types.customers}
												  onChange={(t, c) => setCustomerId(c?.id)}/>
							</Grid>
							<Grid item sm={3}>
								<FormInput field={"title"} label={"Título"}/>
							</Grid>
							<Grid item sm={3}>
								<FormAutocomplete field={"organizationUnit"} label={"Unidad"}
												  type={types.organizationUnits}/>
							</Grid>
							<Grid item sm={3}>
								<FormAutocomplete field={"owner"} label={"Asignado"} type={types.people}/>
							</Grid>

						</Grid>

						<Alert sx={{mb: 1}} color={"info"}>El intervalo de fechas se utilizará para dividir las horas por el
							período</Alert>

						<Grid container spacing={2}>
							<Grid item sm={3}>
								<FormInput type={"date"} field={"startDate"} label={"Inicio"}/>
							</Grid>
							<Grid item sm={3}>
								<FormInput type={"date"} field={"endDate"} label={"Fin"}
										   helperText={"El intervalo de fechas se utilizará para distribuir las horas"}/>
							</Grid>
							<Grid item sm={3}>
								<FormInput type={"date"} field={"guaranteeEndDate"} label={"Fin de Garantía"}/>
							</Grid>
						</Grid>
						<Grid container spacing={2}>
							<Grid item sm={3}>
								<FormInput field={"totalHours"} type={"number"} label={"Total horas"}
										   helperText={"Si es 0 se considera T&M"}/>
							</Grid>
							<Grid item sm={3}>
								<FormInput field={"amountWithoutTaxes"} type={"number"} label={"Importe SIN Iva"}
										   helperText={"Si es 0 se considera T&M"}/>
							</Grid>
							<Grid item sm={3}>
								<TextField
									sx={{width: "5em"}}
									disabled
									label={"€/h"}
									value={(form.value("amountWithoutTaxes") || 0) / (form.value("totalHours") || 0)}
								/>
							</Grid>
						</Grid>

						<FormToggle field={"completed"}
									label={"Completado"}/>

						<FormInput field={"analysisLocation"}
								   label={"Ubicación del análisis"}
								   helperText={"Indicar la ubicación del documento con el análisis"}
								   rows={1}/>

						<FormInput field={"customerAcceptance"}
								   label={"Ubicación de la aceptación del cliente"}
								   helperText={"Debe estar archivado en Drive o en el correo. Indicar cómo localizarlo"}
								   rows={2}/>

						<FormInput field={"description"} label={"Description"} rows={2}/>
						<FormInput field={"observation"} label={"Observación (privada)"} rows={5}/>

					</Grid>
					<Grid item xs={4}>
						<TextField
							fullWidth
							label={"Notas del cliente"}
							value={customerNotes}
							disabled
							minRows={5}
							multiline={true}
							inputProps={{style: {fontSize: "0.8em"}}}/>
					</Grid>
				</Grid>

			</FormContent>

			<Modal
				open={showLines}
				onClose={_ => setShowLines(false)}>
				<Box sx={dedicationModalStyle}>
					<Typography id="transfer-modal-description">
						<strong>LÍNEAS FACTURADAS</strong><br/><br/>
						<table style={{width: "100%"}}>
							<colgroup>
								<col/>
								<col/>
								<col width={"30%"}/>
								<col/>
							</colgroup>
							<thead>
							<tr>
								<th>Factura</th>
								<th>Fecha</th>
								<th>Concepto</th>
								<th align={"right"}>Unidades</th>
								<th align={"right"}>Importe Unit</th>
								<th align={"right"}>IVA</th>
							</tr>
							</thead>
							<tbody>
							{lines.map(l => (
								<tr key={"line-" + l.id}>
									<td align={"center"}>
										<Link to={"/app/admin/billing/bill/" + l.bill.id}>
											{l.bill?.id}
										</Link>
									</td>
									<td align={"center"}>{l.bill?.issueDate}</td>
									<td>{l.concept}</td>
									<td align={"right"}>{numberToString(l.quantity)}</td>
									<td align={"right"}>{numberToString(l.unitNetPrice)}</td>
									<td align={"right"}>{l.taxType}</td>
								</tr>
							))}
							{lines.length == 0 && (
								<tr>
									<td colSpan={6}>No hay líneas facturadas</td>
								</tr>
							)}
							</tbody>
							<tfoot>
							<tr>
								<td style={{fontWeight: "bold"}} align={"right"} colSpan={3}>
									Facturadas
								</td>
								<td style={{fontWeight: "bold"}} align={"right"}>{totalQuantity(lines)}</td>
								<td style={{fontWeight: "bold"}} align={"right"}>{averagePriceHour(lines)}</td>
								<td style={{fontWeight: "bold"}} align={"right"}></td>
							</tr>
							{form.value("totalHours") > 0 && (
								<>
									<tr>
										<td style={{fontWeight: "bold"}} align={"right"} colSpan={3}>
											Totales
										</td>
										<td style={{fontWeight: "bold"}}
											align={"right"}>{numberToString(form.value("totalHours"))}</td>
										<td style={{fontWeight: "bold"}} align={"right"}></td>
										<td style={{fontWeight: "bold"}} align={"right"}></td>
									</tr>
									<tr>
										<td style={{fontWeight: "bold"}} align={"right"} colSpan={3}>
											Diferencia
										</td>
										<td style={{fontWeight: "bold"}}
											align={"right"}>{numberToString(form.value("totalHours") - parseFloat(totalQuantity(lines)))}</td>
										<td style={{fontWeight: "bold"}} align={"right"}></td>
										<td style={{fontWeight: "bold"}} align={"right"}></td>
									</tr>
								</>
							)}
							</tfoot>
						</table>

					</Typography>
				</Box>
			</Modal>
		</>
	);
};